// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"89d33f27","488":"328ec08b","977":"e05582e0"}[chunkId] + ".chunk.js";
};